import { SettingsContext } from '@f_qwep/context/Settings_context';
import React, { useContext, useEffect, useState } from 'react';
import { AccountsContext } from '@f_qwep/context/Accounts_context';
import GeneralJoyride from '../GeneralJoyride';
import { ManualContext } from '@f_qwep/context/Manual_context';
import { IconMaskotMoney } from '@f_components/icons/IconMaskotMoney';

export function AddVendorManual() {
    const { selectedPageName, setSelectedPageName } = useContext(SettingsContext);
    const { isLoadingSuppliers } = useContext(AccountsContext);
    const { setChooseManual, newManualValue, setNewManualValue } = useContext(ManualContext);

    const [run, setRun] = useState(false);
    const [currentStep, setCurrentStep] = useState(0);
    const [targetLoaded, setTargetLoaded] = useState(false);
    const [steps, setSteps] = useState<any>([
        {
            target: '#settings',
            content: (
                <div>
                    <IconMaskotMoney />
                    <p>Для начала работы Вам необходимо перейти в "Настройки"</p>
                </div>
            ),
            disableBeacon: true,
            hideFooter: true,
            spotlightClicks: true,
        },
        {
            target: '#addSupplier',
            content: 'Нажать кнопку "Добавить поставщика',
            disableBeacon: true,
            hideFooter: true,
            spotlightClicks: true,
        },
        {
            target: '#searchAccount',
            content: 'Ввести название поставщика и ознакомиться с инструкцией авторизации',
            disableBeacon: true,
            hideFooter: true,
            spotlightClicks: false,
        },
    ]);

    useEffect(() => {
        const target = document.querySelector('#searchAccount');
        if (target) {
            setTargetLoaded(true);
        }
    }, [isLoadingSuppliers]);

    useEffect(() => {
        if (window.location.pathname == '/app-qwep/' || window.location.pathname == '/app-qwep') {
            setRun(true);
            setSelectedPageName('accounts');
            if (!newManualValue.settings?.flag) {
                setNewManualValue({ ...newManualValue, settings: { flag: true } });
            }
        }
    }, []);

    useEffect(() => {
        if (window.location.pathname == '/app-qwep/settings') {
            if (selectedPageName == 'suppliers') {
                if (targetLoaded && !isLoadingSuppliers) {
                    setCurrentStep((prevStep) => prevStep + 1);
                }
            } else {
                setTimeout(() => {
                    setCurrentStep((prevStep) => prevStep + 1);
                }, 100);
            }
        }
    }, [window.location.pathname, selectedPageName, targetLoaded]);

    const handleJoyrideCallback = (data: any) => {
        const { action, step, index, status, type } = data;

        if (type === 'step:after' && action === 'next' && !step.hideFooter) {
            setCurrentStep((prevStep) => prevStep + 1);
        } else if (type === 'step:before') {
        } else if (
            type === 'step:after' &&
            (action === 'skip' || action === 'close' || action === 'last' || action === 'skip')
        ) {
            setCurrentStep(0);
            setChooseManual();

            setRun(false);
        }
    };

    return (
        <div>
            <GeneralJoyride steps={steps} run={run} callback={handleJoyrideCallback} stepIndex={currentStep} />
        </div>
    );
}
